const chapterColors = {
  
    //  Not a chapter, default black!
    chapter00Color: '#000000',
    //
    chapter01Color: '#5CA904',
    chapter02Color: '#870BE6',
    chapter03Color: '#E10101',
    chapter04Color: '#000137',
    chapter05Color: '#98FB98',
    chapter06Color: '#F88CFA',
    chapter07Color: '#191970',
    chapter08Color: '#F4C430',
    chapter09Color: '#FF0090',
    chapter10Color: '#FF6802',
    chapter11Color: '#E53A3C',
    chapter12Color: '#43E6E5',
    chapter13Color: '#652A0E',
    chapter14Color: '#E0AC69',
    chapter15Color: '#DFD0B7',
    chapter16Color: '#FFF305',
    chapter17Color: '#E0115F',
    chapter18Color: '#0029FF',
    chapter19Color: '#EC9006',
    chapter20Color: '#59F5BE',
    chapter21Color: '#89FD0D',
    chapter22Color: '#0C96E8',
    chapter23Color: '#4B0076',
    chapter24Color: '#006400',
    chapter25Color: '#56ACDB',
    chapter26Color: '#F7F7A1',
  };
  
  export default chapterColors;